import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { Checkbox, CHECKBOX_SIZE } from '../../../Checkbox'
import { FormActions } from '../../../Form'
import { FormikField, getFormikCheckboxFieldValueProps } from '../../../Formik'
import { USER_INVITATION_FORM_FIELD_WITH_SMS } from '../UserInvitationForm.constants'

import * as styles from './UserInvitationFormActions.module.css'

function UserInvitationFormActions({ smsEnable, onOpenInitTab, ...restProps }) {
  const { t } = useTranslation()

  function handleChange(value) {
    if (!value) {
      onOpenInitTab()
    }
  }

  return (
    <FormActions {...restProps}>
      {smsEnable ? (
        <FormikField
          showTooltip
          Component={Checkbox}
          Field={Fragment}
          className={styles.checkboxWrapper}
          getValueProps={getFormikCheckboxFieldValueProps}
          label={t('User.SendWithSMSLabelKey')}
          labelClassName={styles.checkboxLabel}
          name={USER_INVITATION_FORM_FIELD_WITH_SMS}
          size={CHECKBOX_SIZE.small}
          onChange={handleChange}
        />
      ) : null}
    </FormActions>
  )
}

export default UserInvitationFormActions
